/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';
import { DataFormField, DataFormModel } from '../../state/data-form.model';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StringFieldComponent } from './string-field/string-field.component';
import { NumberFieldComponent } from './number-field/number-field.component';
import { DateFieldComponent } from './date-field/date-field.component';
import { LinkFieldComponent } from './link-field/link-field.component';
import { ReportlinkFieldComponent } from './reportlink-field/reportlink-field.component';
import { DocumentLinkFieldComponent } from './document-link-field/document-link-field.component';
import { VideoFieldComponent } from './video-field/video-field.component';
import { QrCodeFieldComponent } from './qr-code-field/qr-code-field.component';
import { TableDropdownComponent } from './tableEditControls/table-dropdown.component';
import { TableDbDropdownComponent } from './tableEditControls/table-db-dropdown.component';

@Component({
    selector: 'dash-gis-base-field',
    templateUrl: './base-field.component.html',
    imports: [
        StringFieldComponent,
        NumberFieldComponent,
        DateFieldComponent,
        LinkFieldComponent,
        ReportlinkFieldComponent,
        DocumentLinkFieldComponent,
        VideoFieldComponent,
        QrCodeFieldComponent,
        FormsModule,
        ReactiveFormsModule,
        TableDropdownComponent,
        TableDbDropdownComponent,
    ],
})
export class BaseFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: any;
    @Input() public tableEditActive: boolean;
    @Input() public tableDataFormName: string;
    @Input() public dataFormGroup: UntypedFormGroup;
    @Input() public dataForm: DataFormModel;
    @Input() public dropdownParameterValue: any;

    get dataFormField(): DataFormField {
        let f = null;
        if (this.dataForm) {
            f = this.dataForm.definition.fields.find((field) => field.fieldName === this.fieldDefinition.name);
        }
        return f;
    }

    get isEditable(): boolean {
        return !!this.dataFormField;
    }
}
